// DataCache is a generic interface for cache implementations to be hooked with
// axios apis.
// CacheManager manages cache instances. Used for backward compatibility with
// openui-framework as well as to share cache across applications in suite.
export class CacheManager {
  constructor() {
    this.store = new Map();
  }
  addCache(c) {
    this.store.set(c.name, c);
  }
  getCache(n) {
    return this.store.get(n);
  }

  // findCache return cache that can handle input request, if any.
  findCache(c) {
    if (this.store.size < 1) return;
    for (const entry of this.store) {
      if (entry[1].canHandle(c)) {
        return entry[1];
      }
    }
  }
  static get instance() {
    if (CacheManager._instance === undefined) {
      CacheManager._instance = new CacheManager();
    }
    return CacheManager._instance;
  }
}
//# sourceMappingURL=index.js.map